export interface BlogArticleMeta {
  slug: string;
  keyword: string;
  title: string;
  date: string;
}

interface BlogKeywordsFile {
  version: number;
  articles: BlogArticleMeta[];
}

import keywordData from './keywords.json';

const data = keywordData as BlogKeywordsFile;

export const BLOG_BASE_PATH = '/blog';

export const blogArticles: BlogArticleMeta[] = data.articles;

export function getArticle(slug: string): BlogArticleMeta | undefined {
  return blogArticles.find((a) => a.slug === slug);
}

export function getArticleUrl(slug: string): string {
  return `${BLOG_BASE_PATH}/${slug}`;
}

export function getArticleByKeyword(keyword: string): BlogArticleMeta | undefined {
  return blogArticles.find((a) => a.keyword === keyword);
}
